import React from 'react';

// Components
import Sidebar from '../../components/Sidebar';
import Form from './PaymentStock/Form';

function PaymentStock() {
  return (
    <div className="WarehouseStock">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              <Form
                name={'ตรวจสอบค้างจ่าย'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentStock;
